module.exports = __webpack_public_path__ + "img/icon_lrtt.9097c2e2.png";